import React from 'react'

import Base from '../_Base'

const UniversalPg = (props) => (
  <Base width="38" height="22" viewBox="0 0 38 22" fill="none" {...props}>
    <path
      d="M3.701 1.642A2 2 0 0 1 5.67 0h29.935a2 2 0 0 1 1.967 2.358l-3.272 18A2 2 0 0 1 32.33 22H2.396A2 2 0 0 1 .43 19.642l3.272-18Z"
      fill="#4A4E58"
      fillOpacity=".7"
    />
    <path
      d="m9.586 17 1.69-10.182h3.818c.782 0 1.415.146 1.9.438.483.288.82.687 1.009 1.198.189.507.228 1.085.119 1.735a4.081 4.081 0 0 1-.701 1.74c-.358.507-.83.906-1.417 1.198-.587.288-1.273.433-2.058.433h-2.53l.253-1.517h2.282c.457 0 .845-.08 1.163-.238.322-.16.575-.378.76-.657.186-.278.309-.598.369-.96.056-.36.038-.679-.055-.954a1.141 1.141 0 0 0-.542-.641c-.265-.156-.628-.234-1.089-.234h-1.69L11.43 17H9.586ZM26.546 10.07a2.583 2.583 0 0 0-.199-.721 1.618 1.618 0 0 0-.98-.895 2.499 2.499 0 0 0-.81-.12c-.546 0-1.065.138-1.555.413-.491.275-.91.68-1.258 1.213-.348.53-.585 1.177-.711 1.94-.126.768-.12 1.42.02 1.953.139.534.394.94.765 1.218.375.275.845.413 1.412.413.52 0 .993-.1 1.417-.299.424-.199.776-.48 1.054-.845.282-.368.46-.799.537-1.292l.408.064h-2.77l.25-1.442h4.13l-.208 1.223c-.143.875-.453 1.631-.93 2.268a4.818 4.818 0 0 1-1.775 1.466 5.262 5.262 0 0 1-2.322.512c-.934 0-1.721-.21-2.361-.631-.637-.424-1.087-1.026-1.352-1.805-.265-.782-.309-1.71-.13-2.784a7.193 7.193 0 0 1 .706-2.202 5.988 5.988 0 0 1 1.253-1.646 5.261 5.261 0 0 1 3.565-1.392c.56 0 1.07.083 1.531.249.46.162.855.394 1.183.696.332.301.585.66.761 1.073.176.415.259.872.248 1.373h-1.879Z"
      fill="#BBB"
    />
  </Base>
)

export default UniversalPg
